import { Chip, Stack } from '@mui/material';
import { get } from 'lodash';
import { useRecordContext } from 'react-admin';

type ChipListFieldProps = {
  source: string;
  label?: string;
  max?: number;
};

type ChipItem = string | number | { label?: string; device_type?: string; software_release?: string; count?: number };

const labelFor = (item: ChipItem): string => {
  if (item === null || item === undefined) {
    return '';
  }
  if (typeof item === 'string' || typeof item === 'number') {
    return String(item);
  }
  const base = item.label ?? item.device_type ?? item.software_release ?? '';
  return item.count !== undefined ? `${base} (${item.count})` : String(base);
};

const ChipListField = ({ source, max }: ChipListFieldProps) => {
  const record = useRecordContext();
  const list: ChipItem[] = get(record || {}, source, []) || [];

  if (!Array.isArray(list) || list.length === 0) {
    return <span>-</span>;
  }

  const visible = max ? list.slice(0, max) : list;
  const remainder = list.length - visible.length;

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {visible.map((item, index) => (
        <Chip key={`${source}.${index}`} size="small" label={labelFor(item)} />
      ))}
      {remainder > 0 && <Chip size="small" variant="outlined" label={`+${remainder}`} />}
    </Stack>
  );
};

export default ChipListField;
